module.exports = __webpack_public_path__ + "img/yiyao_duotang_suoluetu.4c4af59a.png";